import { EVENT_PING, EVENT_PONG, EVENT_AUTH } from '@/constants/webSocket'
import {
  getKeychainString,
  parseKeychainString,
  getOrderlyKey,
  getRequestSignature
} from '@/utils/authentication'

function send(ws, data, stringify = true) {
  if (ws.readyState === WebSocket.OPEN) {
    data = stringify ? JSON.stringify(data) : data
    ws.send(data)
  }
}

export function request(ws, { id, params }) {
  send(ws, { id, event: 'request', params })
}

export function subscribe(ws, { id, topic }) {
  id = id || topic
  send(ws, { id, event: 'subscribe', topic })
}

export function unSubscribe(ws, { id, topic }) {
  send(ws, { id, event: 'unsubscribe', topic })
}

export function ping(ws) {
  send(ws, { event: EVENT_PING, ts: Date.now() })
}

export function pong(ws) {
  send(ws, { event: EVENT_PONG, ts: Date.now() })
}

export function subscribeTopics(ws, topics = []) {
  topics.forEach(params => subscribe(ws, params))
}

export function unSubscribeTopics(ws, topics = []) {
  topics.forEach(params => unSubscribe(ws, params))
}

export function auth(ws) {
  const timestamp = Date.now()
  const { orderlyKeyPair } = parseKeychainString(getKeychainString())
  send(ws, {
    id: '123r',
    event: EVENT_AUTH,
    params: {
      orderly_key: getOrderlyKey(orderlyKeyPair),
      sign: getRequestSignature(orderlyKeyPair, { timestamp }),
      timestamp
    }
  })
}
